const appointmentAction = {
  name: {
    label: "Nom",
    invalid: {
      assertEmpty: "Le nom ne peut pas être vide."
    }
  },
  code: {
    label: "Code",
    invalid: {
      assertEmpty: "Le code ne peut pas être vide."
    }
  },
  description: {
    label: "Description",
    invalid: {
      assertEmpty: "Le description ne peut pas être vide."
    }
  },
  price: {
    label: "Prix",
    invalid: {}
  },
  quantityCredit: {
    label: "Crédit",
    invalid: {
      assertEmpty: "Les crédits ne peut pas être vide."
    }
  },
  active: {
    label: "Actif",
    invalid: {}
  },
  lastPriceModifiedAt: {
    label: "Date de dernière modification",
    invalid: {}
  },
  allTicketGroup: {
    label: "Accepter tous les groupes de ticket",
    invalid: {}
  },
  ticketGroups: {
    label: "Groupes de ticket inclus",
    invalid: {}
  },
  allProductFamily: {
    label: "Accepter toutes les familles de produit",
    invalid: {}
  },
  productFamilies: {
    label: "Familles de produit incluses",
    invalid: {}
  },
  allProductSubFamily: {
    label: "Accepter toutes les sous familles de produit",
    invalid: {}
  },
  productSubFamilies: {
    label: "Sous familles de produit incluses",
    invalid: {}
  },
};

export default appointmentAction;
